import React, {useEffect} from 'react';

import {PageWrapperContent} from 'presentation/components';
import {HomeEnum, QueryParamsForTaggingEnum} from 'presentation/constants';
import {Navigate} from 'react-router-dom';
import {useContractStatus, useHostName} from 'presentation/hooks';
import {useQueryParams, useAccountInformation} from '../hooks';

export function RefundWrapper() {
	const {accesses, odontoOnly} = useAccountInformation();
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();
	const {isValid, isCancelledAtOneYearAndThreeMonths} = useContractStatus();
	const {setSearchParams} = useQueryParams();

	const canAccessRefundServiceBase =
		accesses?.refund && !odontoOnly && (isGndiSaoPaulo || isNotredameSaude);
	const canAccessRefundServiceForValidContract = isValid && canAccessRefundServiceBase;
	const canAccessRefundServiceForInvalidContract =
		isCancelledAtOneYearAndThreeMonths && canAccessRefundServiceBase;

	const canAccessRefundService =
		canAccessRefundServiceForValidContract || canAccessRefundServiceForInvalidContract;

	useEffect(
		() => () => {
			setSearchParams(prev => {
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_STEP);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_TYPE_SERVICE);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_TYPE_PROVIDER);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_SPECIALITY);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_UF);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_CITY);
				prev.delete(QueryParamsForTaggingEnum.REQUEST_REFUND_PROTOCOL_NUMBER);
				return prev;
			});
		},
		[],
	);

	if (!canAccessRefundService) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperContent />;
}
